import { DataContracts } from "../../../../contracts";
export function textDatePeriodTime(masterEvent, dict) {
    if (masterEvent.isLive) {
        if (masterEvent.liveStartCountdown > 0) {
            return `${dict.StartsIn} ${masterEvent.formattedCountdown}`;
        }
        if (masterEvent.liveGameState
            && masterEvent.liveGameState.gamePart) {
            return `${dict[masterEvent.liveGameState.gamePart]} ${shouldShowTime(masterEvent) ?
                masterEvent.liveGameState.formattedTime :
                ""}`;
        }
        return "";
    }
    return masterEvent.eventDate;
}
export function textTimeScore(masterEvent) {
    if (masterEvent.isLive) {
        if (masterEvent.liveGameState) {
            return `${masterEvent.score1 || ""}-${masterEvent.score2 || ""}`;
        }
        return "";
    }
    return masterEvent.eventTime;
}
function shouldShowTime(masterEvent) {
    return !getInactiveGamesStates().some(status => (!!masterEvent.liveGameState &&
        (masterEvent.liveGameState.gamePart && masterEvent.liveGameState.gamePart === status
            || masterEvent.liveGameState.gameTime === null)));
}
function getInactiveGamesStates() {
    return [DataContracts.GamePart.BreakAfterFirstOvertime,
        DataContracts.GamePart.BreakAfterFirstPeriod,
        DataContracts.GamePart.BreakAfterSecondPeriod,
        DataContracts.GamePart.BreakAfterThirdPeriod,
        DataContracts.GamePart.BreakAfterFirstQuarter,
        DataContracts.GamePart.BreakAfterSecondQuarter,
        DataContracts.GamePart.BreakAfterThirdQuarter,
        DataContracts.GamePart.BreakAfterFourthQuarter,
        DataContracts.GamePart.BreakAfterFirstHalf
    ];
}
//# sourceMappingURL=getTextDate.js.map